class PriceProtectionPromiseForm extends HTMLElement {
    email_input_el_selector = '#ppp_email_input'
    name_input_el_selector = '#ppp_full_name_input'
    order_input_el_selector = '#ppp_order_number_input'
    product_sku_input_el_selector = '#ppp_product_sku_input'
    product_price_seen_input_el_selector = '#ppp_price_seen_input'
    product_date_seen_input_el_selector = '#ppp_date_seen_input'
    add_product_btn_selector = '#ppp-add-product'
    rewards_consent_input_el_selector = '#ppp_rewards_consent_input'
    constructor() {
        super();
        this.form = this.querySelector('form')
        this.email_input_el = this.querySelector(this.email_input_el_selector);
        this.name_input_el = this.querySelector(this.name_input_el_selector);
        this.order_input_el = this.querySelector(this.order_input_el_selector);
        this.product_sku_input_el = this.querySelector(this.product_sku_input_el_selector);
        this.product_price_seen_input_el = this.querySelector(this.product_price_seen_input_el_selector);
        this.product_date_seen_input_el = this.querySelector(this.product_date_seen_input_el_selector);
        this.add_product_btn = this.querySelector(this.add_product_btn_selector);
        this.rewards_consent_input_el = this.querySelector(this.rewards_consent_input_el_selector);
        this.submitEl = this.querySelector('.form-actions input[type="submit"');
        this.validationMsg = JSON.parse(this.dataset.validationMsg.replaceAll('=>', ':'));
    }

    connectedCallback() {
        this.addEventListener('submit', this.handleUserRegistration.bind(this))
        this.add_product_btn.addEventListener('click', this.addProduct.bind(this))
        // The submit button stays disabled until the user ticks the rewards
        // consent checkbox; the backend handles the Yotpo enrolment itself.
        this.rewards_consent_input_el?.addEventListener('change', this.syncSubmitState.bind(this))
        this.validation()
    }

    syncSubmitState() {
        const consented = this.rewards_consent_input_el ? this.rewards_consent_input_el.checked : true;
        this.submitEl.toggleAttribute('disabled', !consented);
    }

    addProduct(evt) {
        evt.preventDefault();
        const newValidationModels = [];
        const productBlockWrap = this.querySelector('.product-block-inner-wrapper');
        const newProductBlock = productBlockWrap.cloneNode(true);
        const deleteProductBlockTriggerEl = newProductBlock.querySelector('.delete-product-row')
        deleteProductBlockTriggerEl.classList.remove('hidden')
        deleteProductBlockTriggerEl.addEventListener('click', this.deleteProduct.bind(this))
        newProductBlock.querySelectorAll('.form-inlineMessage').forEach(msg => msg.remove());
        const counter = document.querySelectorAll('.product-block-inner-wrapper').length + 1;
        newProductBlock.querySelectorAll('input.form-input').forEach((input, i) => {
            const newId = input.id + '-' + counter
            input.value = '';
            input.id = newId
            newValidationModels.push(formValidation.buildRequiredNodValidation('#' + newId, input.dataset.label));
            if (input.name === 'price_seen')
                newValidationModels.push({
                    selector: '#' + newId,
                    validate: 'min-number:1',
                    errorMessage: 'Please enter a valid price'
                });
            else if (input.name === 'date_seen') {
                input.value = new Date().toLocaleDateString('en-CA');
                newValidationModels.push({
                    selector: '#' + newId,
                    validate: (callback, value) => {
                        const inputDate = new Date(value);
                        const today = new Date();
                        inputDate.setHours(0, 0, 0, 0);
                        today.setHours(0, 0, 0, 0);
                        callback(inputDate <= today);
                    },
                    errorMessage: 'Please enter a valid date'
                })
            }
        });
        productBlockWrap.parentNode.insertBefore(newProductBlock, this.add_product_btn);
        newProductBlock.scrollIntoView({ behavior: 'smooth', block: 'start' })
        this.formValidator.add(newValidationModels);
    }

    deleteProduct(evt) {
        evt.preventDefault();
        evt.target.removeEventListener('click', this.deleteProduct.bind(this));
        evt.target.closest('.product-block-inner-wrapper').querySelectorAll('input.form-input').forEach((input, i) => {
            this.formValidator.remove('#' + input.id);
        });
        evt.target.closest('.product-block-inner-wrapper').remove();
    }

    async validation() {
        const nod = await window.waitForMod("nod")
        const formValidation = await window.waitForMod("formValidation")
        if (!nod || !formValidation) {
            console.error("Required modules are not loaded")
            return
        }
        const validationModel = [
            formValidation.buildRequiredNodValidation(this.name_input_el_selector, this.name_input_el.dataset.label),
            formValidation.buildRequiredNodValidation(this.email_input_el_selector, this.email_input_el.dataset.label),
            formValidation.buildRequiredNodValidation(this.order_input_el_selector, this.order_input_el.dataset.label),
            formValidation.buildRequiredNodValidation(this.product_sku_input_el_selector, this.product_sku_input_el.dataset.label),
            formValidation.buildRequiredNodValidation(this.product_price_seen_input_el_selector, this.product_price_seen_input_el.dataset.label),
            formValidation.buildRequiredNodValidation(this.product_date_seen_input_el_selector, this.product_date_seen_input_el.dataset.label),
            {
                selector: this.email_input_el_selector,
                validate: 'email',
                errorMessage: this.validationMsg.email_address
            }, {
                selector: this.product_price_seen_input_el_selector,
                validate: 'min-number:0.1',
                errorMessage: 'Please enter a valid price'
            }, {
                selector: this.product_date_seen_input_el_selector,
                validate: (callback, value) => {
                    const inputDate = new Date(value);
                    const today = new Date();
                    inputDate.setHours(0, 0, 0, 0);
                    today.setHours(0, 0, 0, 0);
                    callback(inputDate <= today);
                },
                errorMessage: 'Please enter a valid date'
            }
        ]
        this.formValidator = nod({ submit: this.submitEl });
        this.formValidator.add(validationModel)
        // Require the rewards consent checkbox so submission stays blocked
        // until the user opts in to the loyalty program.
        if (this.rewards_consent_input_el) {
            this.formValidator.add({
                selector: this.rewards_consent_input_el_selector,
                validate: 'checked',
                errorMessage: 'Please join the rewards program to continue.'
            });
        }
        this.syncSubmitState();
    }

    async handleUserRegistration(evt) {
        evt.preventDefault()
        this.formValidator.performCheck();
        if (this.formValidator.areAll('valid')) {
            await window.luxoLoadSwal?.();
            this.loading()
            const serializedFormData = serializeFormData(this.form)
            if (!Array.isArray(serializedFormData.sku)) {
                serializedFormData.sku = [serializedFormData.sku];
                serializedFormData.price_seen = [serializedFormData.price_seen];
                serializedFormData.date_seen = [serializedFormData.date_seen];
            }
            serializedFormData.products = serializedFormData.sku.map((sku, i) => [sku, +serializedFormData.price_seen[i], serializedFormData.date_seen[i]]);
            const res = await api.luxo.createService(api.luxo.llaravel_config).post(
                '/api/price-protection/claim',
                JSON.stringify(serializedFormData)
            )
            if (res.success) {
                window.swal?.close()
                if (res.data.error)
                    this.showErrorMsg()
                else {
                    this.showSuccessMsg()
                    this.form.reset();
                    this.syncSubmitState();
                }
                const scrollMargin = document.querySelector('sticky-header').getBoundingClientRect().height + 20;
                setTimeout(() => {
                    window.scrollTo({ top: this.form.offsetTop - scrollMargin, behavior: 'smooth' });
                }, 300);
            }
        }
    }

    loading() {
        if (window.swal)
            window.swal.fire({
                allowOutsideClick: false,
                didOpen: () => {
                    window.swal.showLoading();
                },
            })
    }
    showErrorMsg() {
        this.querySelector('.form-msg') && this.querySelector('.form-msg').remove();
        const formMsg = document.createElement('div')
        formMsg.className = 'form-msg form-msg--error'
        formMsg.innerHTML = `
            <div class="form-msg__icon">
                <svg
                aria-hidden="true"
                class="icon icon-close"
                fill="none"
                viewBox="0 0 10 10"
                xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M9.99969 9.47165C9.98965 9.49844 9.97839 9.52462 9.96956 9.55171C9.82407 10.0007 9.28167 10.1525 8.92433 9.84421C8.8948 9.81865 8.86741 9.79064 8.84001 9.76325C7.59054 8.51408 6.34137 7.26491 5.0925 6.01513C5.06511 5.98774 5.0438 5.95425 5.01367 5.9156C4.97166 5.95547 4.94366 5.98104 4.91688 6.00783C3.65827 7.26613 2.39906 8.52382 1.14197 9.78395C0.934691 9.99153 0.694536 10.0594 0.4209 9.9614C-0.00127345 9.81043 -0.134896 9.28203 0.155482 8.94051C0.185006 8.90581 0.217879 8.87416 0.250143 8.84189C1.49931 7.59242 2.74848 6.34325 3.99826 5.09438C4.02566 5.06699 4.05975 5.04629 4.11119 5.00642C4.05822 4.96594 4.02109 4.94341 3.99157 4.91389C2.73509 3.65833 1.47862 2.40246 0.222749 1.14599C-0.0892389 0.833693 -0.0731068 0.378647 0.26871 0.138188C0.365807 0.0700071 0.493037 0.045048 0.606266 0C0.632443 0 0.658315 0 0.684492 0C0.922211 0.028916 1.08658 0.174105 1.24851 0.336643C2.47028 1.56359 3.69571 2.78689 4.92022 4.0111C4.94488 4.03576 4.97106 4.0595 5.01215 4.09846C5.03954 4.06467 5.06115 4.0321 5.08824 4.00471C6.31002 2.78233 7.53332 1.56146 8.75266 0.336643C8.91428 0.174105 9.07834 0.0286116 9.31637 0C9.34254 0 9.36841 0 9.39459 0C9.51269 0.0483962 9.6387 0.0830954 9.74645 0.148232C9.89134 0.235589 9.95039 0.391431 10 0.546968V0.76186C9.95221 0.959706 9.82498 1.10276 9.68466 1.24247C8.45436 2.46882 7.22711 3.6982 5.99773 4.92546C5.97124 4.95194 5.93259 4.96624 5.88602 4.99455C5.94568 5.04538 5.9749 5.06669 6.00016 5.09195C7.23107 6.32225 8.46076 7.55376 9.69349 8.78224C9.83168 8.92012 9.95434 9.06227 10 9.25707V9.47196L9.99969 9.47165Z" fill="#282829"></path>
                </svg>
            </div>
            <div class="form-msg__text">
                <h3 class="form-msg__text-heading">Invalid order number</h3>
                <div class="form-msg__text-body">
                    <p>This order number is not connected to a valid order. Please check your entry and try again.</p>
                </div>
            </div>
        `
        this.form.insertBefore(formMsg, this.form.firstChild);

    }
    showSuccessMsg() {
        this.querySelector('.form-msg') && this.querySelector('.form-msg').remove();
        const formMsg = document.createElement('div')
        formMsg.className = 'form-msg'
        formMsg.innerHTML = `
            <div class="form-msg__icon">
                <svg
                class="icon icon-checkmark"
                aria-hidden="true"
                focusable="false"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 12 9"
                fill="none"
                >
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"/>
                </svg>
            </div>
            <div class="form-msg__text">
                <h3 class="form-msg__text-heading">Request received</h3>
                <div class="form-msg__text-body">
                    <p>Thank you — your request has been submitted successfully. Our team will review the details and be in touch within 3 business days.</p>
                </div>
            </div>
        `
        this.form.insertBefore(formMsg, this.form.firstChild);
    }
}

customElements.define('price-protection-form', PriceProtectionPromiseForm);
